
import React, {Component, MouseEvent} from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import {Fader} from 'ui-components/animations';
import debounce from 'lodash/debounce';

const TOOLTIP_DEFAULT_STYLE = {
	position: 'fixed',
	display: 'inline-block',
	padding: '0.5em',
	backgroundColor: 'black',
	maxWidth: '200px',
	boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.2)",
	color: 'white',
	zIndex: 1000
};

export interface DecoratorProps{
	tooltip?: string;
	text?: string;
	title?: string;
}
export function tooltipDecorator(WrappedComponent) : any{
	return class Decorated extends Component<DecoratorProps>{
		render(){
			let {
				tooltip,
				title,
				text,
				...props
			} = this.props;
			return tooltip || title || text
				? <ToolTip text={tooltip || title || text}>
					<WrappedComponent {...props}/>
				</ToolTip>
				: <WrappedComponent {...props}/>;
		}
	}
}

export interface ToolTipProps{
	debounceTime?: number;
	style?: any;
	defaultStyle?: any;
	position?: string;
	offsetX?: number;
	offsetY?: number;
	text?: string;
	title?: string;
}


export default class ToolTip extends Component<ToolTipProps, any>{
	
	public el: Element;
	public wrapper: Element;


/* 	static propTypes = {
		text: PropTypes.string,
		title: PropTypes.string,
		debounceTime: PropTypes.number
	};
 */
	static defaultProps = {
		debounceTime: 150,
		style: {},
		defaultStyle: TOOLTIP_DEFAULT_STYLE,
		position: "top",
		offsetX: -50,
		offsetY: -10
	}

	constructor(props){
		super(props);
		this.state = {
			visible: false,
			position: {
				left: '0px',
				top: '0px'
			}
		};
		// debounce state updates for performance
		this.stateUpdate = debounce(
			this.stateUpdate,
			props.debounceTime
		);
		this.el = document.createElement('div');
	}

	componentWillMount(){
		document.body
		.appendChild(this.el);
	}

	componentWillUnMount(){
		document.body
		.removeChild(this.el);
	}

	onMouseOver = (e: MouseEvent<HTMLDivElement>) => {
		let {
			position,
			offsetX,
			offsetY
		} = this.props;

		let scrollLeft, scrollTop;
		if (this.wrapper){
			let doc = document.documentElement;
			let rect = this.wrapper.getBoundingClientRect();
			scrollLeft = window.pageXOffset || doc.scrollLeft,
			scrollTop = window.pageYOffset || doc.scrollTop;
			let wrapperX = rect.left + scrollLeft;
			let wrapperY = rect.top + scrollTop;

			let pos = {};
			if (position == 'top'){
				pos = {
					left: `${wrapperX + offsetX}px`,
					bottom: `calc(100% - ${wrapperY + offsetY}px)`
				};
			}
			else if (position == 'left'){
				pos = {
					right: `calc(100% - ${wrapperX}px)`,
					top: `${wrapperY}px`
				};	
			}
			else{
				pos = {
					left: `${e.pageX}px`,
					top: `${e.pageY}px`
				}
			}

			this.stateUpdate({
				visible: true,
				position: pos
			});
		}
	}

	onMouseOut = () => {
		this.stateUpdate({visible: false});
	}

	onClick = () => {
		this.stateUpdate({visible: false});
	}

	stateUpdate = (upd) => {
		this.setState(upd);
	}

	wrapperLoaded = (wrapper: Element) => {
		this.wrapper = wrapper;
	}

	render(){
		let {
			text,
			title,
			children,
			style,
			defaultStyle
		} = this.props;
		let {
			position,
			visible
		} = this.state;

		return [
			(<div
				key="tooltip-wrap"
				className="tooltip-wrap"
				ref={this.wrapperLoaded}
				onMouseOver={this.onMouseOver}
				onMouseOut={this.onMouseOut}
				onClick={this.onClick}
			>{
				children
			}</div>),

			visible && ReactDOM.createPortal(
				visible && (
					<div
						className="tooltip-overlay"
						style={Object.assign(
							{pointerEvents: "none"},
							defaultStyle,
							position,
							style
						)}
					>{title || text}</div>
				),
				this.el
			)
		]
	}

}
